import { useState, useEffect } from "react";
import { client } from "../../sanityClient";
import NepaliDatePicker from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';
import "./EditMoneyForm.css";

export default function EditMoneyForm({ transaction, onClose, onUpdate }) {
    const [form, setForm] = useState({
        givenOrTaken: transaction.givenOrTaken,
        amount: transaction.amount,
        date: transaction.date.split("T")[0],
        remarks: transaction.remarks || "",
        MTrID: transaction.MTrID,
        userId: transaction.user?._id || ""
    });
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        client.fetch(`*[_type == "user"]{_id, username}`).then(setUsers);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await client
                .patch(transaction._id)
                .set({
                    givenOrTaken: form.givenOrTaken,
                    amount: +form.amount,
                    date: new Date(form.date).toISOString(),
                    remarks: form.remarks,
                    user: { _type: "reference", _ref: form.userId }
                })
                .commit();

            onUpdate();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Failed to update transaction");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="edit-money-modal" onClick={onClose}>
            <div className="edit-money-content" onClick={(e) => e.stopPropagation()}>
                <div className="edit-money-header">
                    <h5 className="edit-money-title">Edit Transaction</h5>
                    <button className="edit-money-close" onClick={onClose}>×</button>
                </div>
                <div className="edit-money-body">
                    <form onSubmit={handleSubmit}>
                        <div className="edit-money-group">
                            <label className="edit-money-label">Transaction ID</label>
                            <input type="text" className="edit-money-input" value={form.MTrID} disabled style={{ backgroundColor: "#f1f5f9", color: "#475569" }} />
                        </div>

                        <div className="edit-money-group">
                            <label className="edit-money-label">User</label>
                            <select className="edit-money-input" value={form.userId} onChange={(e) => setForm({ ...form, userId: e.target.value })} required disabled={loading}>
                                <option value="">Select User</option>
                                {users.map(u => (
                                    <option key={u._id} value={u._id}>{u.username}</option>
                                ))}
                            </select>
                        </div>

                        <div className="edit-money-group">
                            <label className="edit-money-label">Type</label>
                            <select className="edit-money-input" value={form.givenOrTaken} onChange={(e) => setForm({ ...form, givenOrTaken: e.target.value })} disabled={loading}>
                                <option value="Debit">Debit</option>
                                <option value="Credit">Credit</option>
                            </select>
                        </div>

                        <div className="edit-money-group">
                            <label className="edit-money-label">Amount (₹)</label>
                            <input type="number" className="edit-money-input" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} required disabled={loading} />
                        </div>

                        <div className="edit-money-group">
                            <label className="edit-money-label">Date</label>
                            <NepaliDatePicker
                                value={form.date ? new Date(form.date) : null}
                                onChange={(date) => {
                                    if (date) {
                                        const regularDate = date.toADasDate ? date.toADasDate() : date;
                                        const year = regularDate.getFullYear();
                                        const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                        const day = String(regularDate.getDate()).padStart(2, '0');
                                        const localDateString = `${year}-${month}-${day}`;
                                        setForm(prev => ({ ...prev, date: localDateString }));
                                    } else {
                                        setForm(prev => ({ ...prev, date: null }));
                                    }
                                }}
                                placeholder="Select BS Date"
                                className="edit-money-input"
                                disabled={loading}
                                type="BS"
                            />
                        </div>

                        <div className="edit-money-group">
                            <label className="edit-money-label">Remarks</label>
                            <textarea className="edit-money-input edit-money-textarea" rows="2" value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} disabled={loading} />
                        </div>

                        <button type="submit" className="edit-money-btn" disabled={loading}>
                            {loading ? "Updating..." : "Update Transaction"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}